import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { IonicModule } from '@ionic/angular';
import { NewNavbarComponent } from 'src/app/components/new-navbar/new-navbar.component';
import { ServiceService } from 'src/app/mastermodule/service/service.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-main-layout',
  templateUrl: './main-layout.component.html',
  styleUrls: ['./main-layout.component.scss'],
  standalone: true,
  imports: [CommonModule, IonicModule, NewNavbarComponent],
})
export class MainLayoutComponent implements OnInit {

  constructor(
    private api: ServiceService
  ) { }

  ngOnInit() {
    this.dummy_api_ony_for_verification();
  }

  dummy_api_ony_for_verification() {
    this.api.call_http_post({
      url: environment.API_URL + 'mastermodule/dummy_api_ony_for_verification',
      data: {},
      modname: '',
      successCb: (res) => {
        var result = res.data;
      },
    });
  }
}
